var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 33,
    rx: 10,
    fill: "#737373"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0403 19.1847C13.5716 19.1847 13.1691 19.0189 12.8329 18.6875C12.5015 18.3513 12.3358 17.9489 12.3358 17.4801C12.3358 17.0161 12.5015 16.6184 12.8329 16.2869C13.1691 15.9555 13.5716 15.7898 14.0403 15.7898C14.4949 15.7898 14.8926 15.9555 15.2335 16.2869C15.5744 16.6184 15.7449 17.0161 15.7449 17.4801C15.7449 17.7926 15.6644 18.0791 15.5034 18.3395C15.3471 18.5952 15.1412 18.8011 14.8855 18.9574C14.6298 19.1089 14.3481 19.1847 14.0403 19.1847ZM19.9973 19.1847C19.5286 19.1847 19.1261 19.0189 18.79 18.6875C18.4585 18.3513 18.2928 17.9489 18.2928 17.4801C18.2928 17.0161 18.4585 16.6184 18.79 16.2869C19.1261 15.9555 19.5286 15.7898 19.9973 15.7898C20.4519 15.7898 20.8496 15.9555 21.1905 16.2869C21.5314 16.6184 21.7019 17.0161 21.7019 17.4801C21.7019 17.7926 21.6214 18.0791 21.4604 18.3395C21.3042 18.5952 21.0982 18.8011 20.8425 18.9574C20.5868 19.1089 20.3051 19.1847 19.9973 19.1847ZM25.9544 19.1847C25.4856 19.1847 25.0832 19.0189 24.747 18.6875C24.4155 18.3513 24.2498 17.9489 24.2498 17.4801C24.2498 17.0161 24.4155 16.6184 24.747 16.2869C25.0832 15.9555 25.4856 15.7898 25.9544 15.7898C26.4089 15.7898 26.8066 15.9555 27.1475 16.2869C27.4885 16.6184 27.6589 17.0161 27.6589 17.4801C27.6589 17.7926 27.5784 18.0791 27.4174 18.3395C27.2612 18.5952 27.0552 18.8011 26.7995 18.9574C26.5439 19.1089 26.2621 19.1847 25.9544 19.1847Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.04f7182e4e859e7a1ba64a59f73fd62e.svg";
export { ForwardRef as ReactComponent };